module.exports = __webpack_public_path__ + "static/media/og.d7331557.png";